import { mapActions, mapGetters, mapMutations } from 'vuex';
import { validateTaxCode, validateIdentificationNumber } from '@/common/taxCode/taxCodeUtil';
export default {
	data() {
		return {};
	},
	computed: {
		isShowViewDetailSeller() {
			const me = this;
			//thông tin MST người bán là MST
			if (me.currentItem && validateTaxCode(me.currentItem.SellerTaxCode)) {
				return true;
			}

			//Nếu là CCCDan thì thỏa mãn điều kiện sau
			// ORG trả về Ngành nghề kinh doanh của người bán
			// ORG trả về Văn phòng đại diện của người bán
			// ORG trả về nhiều bộ dữ liệu MST - Tên - Địa chỉ (tương ứng với DL của nhiều MST), trong trường hợp MST người bán là định dạng CCCD - (đáp ứng từ PBI 512227)
			if (me.currentItem && validateIdentificationNumber(me.currentItem.SellerTaxCode)) {
				return (
					me.currentItem.CheckingMetadata &&
					(me.currentItem.CheckingMetadata.HasOfficeRepresentativeData ||
						me.currentItem.CheckingMetadata.HasMultipleBusinessLocations)
				);
			}

			return false;
		}
	},
	methods: {
		getIconCheckedSellerMixin(taxCode, checkingResult) {
			const me = this;
			if (!taxCode) return 'mi-icon-v2-checking-result-red-tick';

			const sellerStatus = me.getDefineSellerStatus(checkingResult);
			if (sellerStatus == me.$ms.enum.CheckingStatus.Valid) {
				return 'mi-icon-v2-checking-result-green-tick';
			}
			if (sellerStatus == me.$ms.enum.CheckingStatus.Invalid) {
				return 'mi-icon-v2-checking-result-red-tick';
			}
			return 'mi-icon-v2-checking-result-load-orange';
		}
	}
};
